import { StyleSheet } from 'react-native';
import Colors from "../../tools/Colors";
import React from "react";

export default StyleSheet.create({
  baseStyle: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 9999,
  },
  bgTransparent: {
    width:'100%',
    backgroundColor: 'transparent',
      alignItems:'center',
      justifyContent:'center',
  },
  bgNotTransparent: {
      width:'100%',
    //backgroundColor: Colors.gray,
      alignItems:'center',
      justifyContent:'center',
     // opacity:0.8,
  },
  hidden: {
    display: 'none',
  },
  visible: {
    display: 'flex',
  },
});
